import React, { useEffect } from 'react';
import {
    Link
} from "react-router-dom";
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import './Welcome.css';
import CheckMark from '../../assets/images/tick.svg';

import {
    setTransactionId,
    getExamCenters,
    getInstitutions
    // getTranscriptsCost
} from './../../redux-building-blocks/actions';

import { isEmpty } from 'lodash';

const Welcome = (props) => {
    
    useEffect(() => {
       
        // initiating centre,institution and transcript cost api call if this value is empty
        if(isEmpty(props.examCenterList)) {
            props.getExamCenters();
        }

        if(isEmpty(props.institutionList)) {
            props.getInstitutions();
        }

        // if(isEmpty(props.transcriptRates.transcriptsCost)) {
        //     props.getTranscriptsCost(uuidv4());
        // }

        // set once from here only not from any other component(except personal info on condition)
        props.setTransactionId(uuidv4());
      
 
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
   
    // const Fee = (props) =>{
    //     if(props.transcriptRates.transcriptsCost.length>0){
    //         const rate = props.transcriptRates.transcriptsCost.filter(r=>r.countryCode === 'US');
    //         return rate[0].amount;
    //     }
    // }

    return (
        <div className="container-fluid p-0">
            <div className="welcome-wrapper">
                <h1 className="heading-h1">Cambridge International Education's US Grade Transcript Service</h1>
                <p>
                This convenient online service enables US students to send official AS & A Level grade transcripts and AICE Diploma notification to US colleges and universities.
                </p>
                <p>
                Research credit policies, track your requests, and view the grades you sent to institutions with ease. Just click “Start” below to create a Cambridge account and begin. Note: students under 16 must get a parent or guardian’s permission to create an account.
                </p>
                <h2 className='heading-h2'>Fees and timing</h2>            
                 <p>Each transcript sent to an institution requires a $17 fee. After payment is received, transcripts will be sent within 14 days. Pre-ordered transcripts will be available to institutions within 14 days after results release day.</p>
                <p>
                You will need: 
                </p>
            </div>
            <div className="row Welcome mr-0">
                <div className="col-lg-3 col-md-3 col-sm-12 mb-2">
                    <div className="CardHeader card">
                        <span>Personal</span>
                        <span>information</span>
                    </div>
                    <div className="row card WelcomeCard">
                        <div className="row PaddCard pt-2">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                                <p className="mb-1">Candidate's <b>name, date of birth,</b> and <b>email</b> (will appear on transcripts)</p>
                            </div>
                        </div>
                        <div className="row PaddCard">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                                <p className="mb-0"><b>Official identity document</b> as a PDF, JPEG, JPG, PNG, or Android image file.</p>
                                <p className="mb-1">Accepted IDs:</p>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 pl-1 col-sm-12 col-12">
                                        <ul className="bulletCss">
                                            <li>Passport</li>
                                            <li>Birth certificate</li>
                                            <li>State-issued driver's license, learner's permit, or ID</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 mb-2">
                    <div className="CardHeader card">
                        <span>Exam</span>
                        <span>details</span>
                    </div>
                    <div className="row card WelcomeCard">
                        <div className="row PaddCard pt-2">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                                <p className="mb-1">Add all <b>exam series</b> </p>
                            </div>
                        </div>
                        <div className="row PaddCard">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                                <p className="mb-1">For each series: </p>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 pl-1 col-sm-12 col-12">
                                        <ul className="bulletCss mb-0">
                                            <li><b>Month and year</b></li>
                                            <li><b>Center number or name</b></li>
                                            <li>Candidate number (optional)</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row PaddCard">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                                <p className="mb-1">Future series availability:</p>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 pl-1 col-sm-12 col-12">
                                        <ul className="bulletCss">
                                            <li>June series—in form starting late February</li>
                                            <li>November series—in form starting mid-August</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 mb-2">
                    <div className="CardHeader card">
                        <span>Institution</span>
                        <span>details</span>
                    </div>
                    <div className="row card WelcomeCard">
                        <div className="row PaddCard pt-2">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                                <p className="mb-1">Add <b>up to 6 institution(s),</b> e.g. university or college (search in form)</p>
                            </div>
                        </div>  
                        <div className="row PaddCard">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                                <p className="mb-1">To send to more than 6, resubmit the form</p>
                            </div>
                        </div> 
                        <div className="row PaddCard">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                            <p className="mb-1"><b>$17 fee</b> per institution </p>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 mb-2">
                    <div className="CardHeader card">
                        <span>Payment</span>
                        
                    </div>
                    <div className="row card WelcomeCard">                      
                        <div className="row PaddCard pt-2">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-2 cardBody">
                                {<img src={CheckMark} className="" alt="Tick Mark" />}
                            </div>
                            <div className="col-lg-10 col-md-10 pl-2 col-sm-10 col-10">
                                <p className="mb-1">Pay on secure website with:</p>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 pl-1 col-sm-12 col-12">
                                        <ul className="bulletCss mb-0">
                                            <li><b>A credit card</b> (Visa, Mastercard, or American Express) </li>
                                            <li>Cardholder authorization (if under 18) </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-10 col-md-10 pl-1 col-sm-10 col-10 pl-4">
                            <p className='mb-1'>Note: Please submit payment within 48 hours after you confirm your order; after 48 hours requests expire. </p>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div className="row StartButton">
                <div className="col-12 text-center">
                    <Link to={props.isUserLoggedIn?'/transcript-history':'/login'}>
                        <button type="button" className="btn btn-primary start-button"><span className="font-weight-bold">Start</span></button>
                    </Link>
                    
                </div>
               
            </div>
            <p>View transcript FAQs on <a href="https://www.cambridgeinternational.org/usa/students/get-and-send-exam-grades/">Get and send exam grades</a>. You may contact Customer Services by email <a href="mailto:info@cambridgeinternational.org">info@cambridgeinternational.org</a>, online form: <a href="https://help.cambridgeinternational.org/hc/en-gb/requests/new?ticket_form_id=53542">Submit a request</a>, or phone 917-810-2660 (toll free, open 24 hours from Saturday 8 pm to Friday 7:59 am, Eastern Time).</p>
        </div>
    );
}


const mapStateToProps = state => {
    return { 
        isUserLoggedIn: state.currentUser.isUserLoggedIn,
        examCenterList: state.examDetailsInfo.examCenterApivalues,
        institutionList: state.institutesDetailsInfo.institutionApivalues,
        transcriptRates : state.reviewConfirm,
        tHistory: state.transcriptHistory
     };
};

const mapDispatchToProps = { 
    setTransactionId,
    getExamCenters,
    getInstitutions
    // getTranscriptsCost
 }
  
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Welcome);